import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { RecurringRouteDetailsComponent } from './recurring-route-details.component';
import { QuickAssignEmployeeModule } from '../quick-assign-employee/quick-assign-employee.module';
import { DataPickerModule } from '../data-picker/data-picker.module';
import { PreviewDataModule } from '../preview-data/preview-data.module';
import { CreateRouteFormModule } from '../create-route-form/create-route-form.module';



@NgModule({
  declarations: [
    RecurringRouteDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    QuickAssignEmployeeModule,
    CreateRouteFormModule,
    DataPickerModule,
    PreviewDataModule
  ],
  exports: [
    RecurringRouteDetailsComponent
  ]
})
export class RecurringRouteDetailsModule { }
